import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Popup } from "@progress/kendo-react-popup";
import BookmarksList from "../../../components/Bookmarks/BookmarksList";
import { label, route } from "../../../config";

/**Parent Component :Sidebar
 * @author Sejal
 * Used to render the popup on hover of menu item
 */
const SidePannel = (props) => {
  const operationalTeamName = useSelector((state) => state.auth.user.operationalTeamName);
  const { anchor } = props;
  const [popupAlign, setPopupAlign] = useState({ horizontal: "left", vertical: "top" });
  const [showAnimation, setShowAnimation] = useState(false);

  const anchorAlign = {
    horizontal: "right",
    vertical: "middle",
  };

  /**
   * Handles the animation of the popup when the type prop changes
   * @param {string} props.type - The type of the popup
   * @author Sejal
   */
  useEffect(() => {
    if (props.type) {
      // Small delay to ensure the popup is rendered before animation starts
      const timer = setTimeout(() => {
        setShowAnimation(true);
      }, 50);
      return () => clearTimeout(timer);
    } else {
      setShowAnimation(false);
    }
  }, [props.type]);

  /**
   * @author Sejal
   * @param {String} type
   * @returns label
   */
  const getLabel = (type) => {
    switch (type) {
      case "home":
        return label.FAVORITE_TASKS;
      case "projects":
        return `${label.FAVORITE} ${operationalTeamName}(s)`;
      case "queues":
        return label.FAVORITE_WORKSPACES;
      case "library":
        return label.FAVORITE_DOCUMENTS;
      case "filters":
        return label.FAVORITE_FILTERS;
      default:
        return null;
    }
  };

  return (
    <>
      <Popup
        anchor={anchor.current}
        show={!!props.type}
        className={`bookmarks-container ${showAnimation ? "show" : ""}`}
        collision={{
          horizontal: "fit",
          vertical: "flip",
        }}
        animate={false}
        anchorAlign={anchorAlign}
        popupAlign={popupAlign}>
        <div onMouseEnter={() => props.onPanelEnter?.(props.type)} onMouseLeave={props.onPanelLeave}>
          <span className='top-heading overflow-hidden d-inline-block pl-2 pt-2'>{getLabel(props.type)}</span>
          {props.type === "home" && <BookmarksList type={route.PRIVATE_ROUTE.TASKS.ENTITY_NAME} setType={props.setType} />}
          {props.type === "projects" && <BookmarksList type={route.PRIVATE_ROUTE.PROJECT.ENTITY_NAME} setType={props.setType} />}
          {props.type === "queues" && <BookmarksList type={route.PRIVATE_ROUTE.QUEUES.ENTITY_NAME} setType={props.setType} />}
          {props.type === "library" && <BookmarksList type={route.PRIVATE_ROUTE.CMS.ENTITY_NAME} setType={props.setType} />}
          {props.type === "filters" && <BookmarksList type={label.FAVOURITE_FILTERS_GRID_TYPE} setType={props.setType} />}
        </div>
      </Popup>
    </>
  );
};

export default SidePannel;
